import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

interface PdfViewerModalProps {
  isOpen: boolean;
  onClose: () => void;
  pdfUrl: string;
}

export const PdfViewerModal: React.FC<PdfViewerModalProps> = ({
  isOpen,
  onClose,
  pdfUrl,
}) => {
  const { t } = useTranslation("common");

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl" isCentered>
      <ModalOverlay />
      <ModalContent bg="white" borderRadius="12px" maxH="90vh" h="800px">
        <ModalHeader>
          <Text fontSize="20px" fontWeight="600" color="#1A202C">
            {t("assessments.pdfViewer")}
          </Text>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody p={0} h="calc(100% - 60px)" overflow="hidden">
          <iframe
            src={pdfUrl}
            style={{
              width: "100%",
              height: "100%",
              border: "none",
            }}
            title="PDF Viewer"
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
